var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-info"},[_c('span',[_vm._v(_vm._s(_vm.dateStr))]),_c('span',{staticClass:"ml20"},[_vm._v(_vm._s(_vm.weekStr))]),_c('span',{staticClass:"ml20 time-str"},[_vm._v(_vm._s(_vm.timeStr))])])
}
var staticRenderFns = []

export { render, staticRenderFns }